@let currentRow = row();
@let realisation = currentRow.realisation;
@let isMarkedForRemoval = !!currentRow.form.controls.removed.value;
@let notEditableMessage = realisation | notEditable;
@let notApprovableMessage = realisation | notApprovable;

@if (realisation.entity_id) {
    <div class="name fw-bold lh-1 mb-0">
        @if (realisation.entity?.use_once) {
            {{ realisation.entity?.name }}
        } @else {
            {{ realisation.hiring_name ?? realisation.planning_has?.name }}

            @if (realisation.planning_has?.entitytype_key !== EntityTypeCode.InhuurPersoneel) {
                <small>{{ realisation.planning_has?.entitytype?.name }}</small>
            }
        }
    </div>

    <div class="caption fw-bold text-uppercase">
        {{ realisation.planning_has?.driver_user?.name }}

        @if (!realisation.entity?.use_once) {
            {{ realisation.planning_has?.hiring?.name }}
        }

        @if (realisation.parent_realisation_id) {
            {{ currentRow.parentRealisationUserName }}
        }
    </div>

    @if (notEditableMessage) {
        <div class="no-edit-reason">{{ notEditableMessage }}</div>
    }
}

@if (realisation.user_id) {
    <div class="name fw-bold lh-1 mb-0">{{ realisation.user.name }}</div>

    @if (realisation.hourtype === RealisationHourtype.worktime) {
        <div class="caption fw-bold text-uppercase">
            <small class="function">{{ realisation.user.function }}</small>

            @if (realisation.planning_has?.entity?.use_once) {
                {{ realisation.planning_has?.entity?.name }}
            }

            @if (!realisation.planning_has?.entity?.use_once) {
                {{ realisation.hiring_name ?? realisation.planning_has?.name }}
                <small>{{ realisation.planning_has?.entitytype?.name }}</small>
            }
        </div>
    }

    @if (realisation.planning_has?.comment) {
        <div class="comment">{{ realisation.planning_has?.comment }}</div>
    }

    @if (notEditableMessage) {
        <div class="no-edit-reason">{{ notEditableMessage }}</div>
    } @else if (notApprovableMessage) {
        <div class="no-edit-reason">{{ notApprovableMessage }}</div>
    }

    @if (isMarkedForRemoval && !notEditableMessage) {
        <div class="no-edit-reason">
            Deze registratie is verwijderd {{ !realisation.approved ? 'door de gebruiker' : '' }}
        </div>
    }

    <!-- Toon de uitvoerder alleen bij goedkeurrecht, als uitvoerderscontext nodig is en een naam of ID bekend is. -->
    @if (canApproveHours && currentRow.showContextPerformer && (currentRow.performerName || currentRow.performerId)) {
        <div class="comment">
            <i class="fa-solid fa-user-helmet-safety pe-1" title="Uitvoerder"></i>
            @if (realisation.performer_id) {
                <i class="fa-solid fa-arrow-right pe-1" title="Doorgestuurd"></i>
            }
            {{ currentRow.performerName ?? 'onbekend' }}
        </div>
    }
}
